.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  max-height: 100%;
  width: 100%;
}

.video-player-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 65%;
  width: 100%;
}

.comments-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 0 0 100%;
  max-height: 35%;
  min-height: 35%;

  > div {
    max-height: 100%;
    min-height: 100%;

    & textarea {
      min-height: 4rem;
    }
  }
}

.video-info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1.6rem;
  padding: 1.6rem;
  height: 6.4rem;
  background-color: var(--color-grey-9-5);
}

.asset-name {
  font-weight: 500;
  font-size: 1.4rem;
  color: var(--step-title-color);
}

.relative-time {
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.9rem;
  color: var(--color-grey-4);
}
